import React from 'react';
import { useSelector } from 'react-redux';
import '../../../styles/common/Footer/Footer.css'
import Exit from '../../../containers/Exit';
import { Footer as i18n } from '../../../middlewares/i18n';

const FooterV2 = ({ showPhone = true }) => {
  const _i18n = useSelector(state => state.i18n)

  return(
    <div className='footer-container-v2'>
      { showPhone ? <h6 className='bs-subtitle no-margin centered footer-call-v2'>{i18n[_i18n.language.current].message}</h6> : null }
      <div className='footer'/>
      <Exit/>
    </div>
  )
}

export default FooterV2